// src/components/ProtectedRoute.jsx

import React from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext"; // Import Auth Context

const ProtectedRoute = ({children}) => {
    const {user, loading} = useAuth(); // Get user and loading state from Auth Context
    const location = useLocation();

    if (loading) {
        // Optionally, return a loading indicator
        return <p>Loading...</p>;
    }

    if (!user) {
        // If not authenticated, navigate to login with the intended path
        return <Navigate to="/login" state={{from: location}} replace />;
    }

    // If authenticated, render the child components
    return children;
};

export default ProtectedRoute;
